import { render, staticRenderFns } from "./Imprint.vue?vue&type=template&id=320c014c"
import script from "./imprint.ts?vue&type=script&lang=js&external"
export * from "./imprint.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports